module.exports = {
      id: "marker-usage",
      viewBox: "0 0 335.025 20.989",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#marker",
      toString: function () {
        return this.url;
      }
    }